import { render, staticRenderFns } from "./ModalCatalogCategoryExportColunmSettings.vue?vue&type=template&id=7f462e64&"
import script from "./ModalCatalogCategoryExportColunmSettings.vue?vue&type=script&lang=js&"
export * from "./ModalCatalogCategoryExportColunmSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports